import {getUrlPath} from "./get-url-path.ts";

export const getTermsOfServiceUrl = (): string => {
    return getUrlPath("termsOfService");
};
